module.exports = __webpack_public_path__ + "static/img/tzfx@2x.02b8e6f5.png";